module.exports = {
  email: 'master-presentation@ahaslides.com',
}
